
/* injects from baggage-loader */

'use strict';

import ProjectManagerCommentsController from './projectmanager.comments.controller';
import ProjectManagerCommentsTemplate from './projectmanager.comments.html';

export default class ProjectManagerCommentsComponent {
		constructor() {
				this.templateUrl = ProjectManagerCommentsTemplate;
				this.controller = ProjectManagerCommentsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					project: '<',
					comments: '<'
				};
		}
}
